// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__yzxs1","containerItemsCenter":"Skeleton_containerItemsCenter__1jl0A"};